import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {forkJoin} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ControlValueAccessor} from '@angular/forms';
import {DeviceDetectorService} from 'ngx-device-detector';
import _ from 'lodash';
import {MessageService} from 'primeng/api';
import { LocaleService } from '../services/locale.service';


export enum SORT {
  new,
  critical
}

export enum SHOW_PARAM_TYPE {
  cdp,
  ccp
}


@Component({
    selector: 'app-paramlist-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [DialogService, MessageService],
    standalone: false
})
export class ParamListFilterComponent implements ControlValueAccessor, OnInit {

  @Input() optimizeWidth = false;
  @Input() value = {
    displayName: null,
    procName: null,
    tag: null,
    paramTypeSelected: [],
    valueTypeSelected: [],
    lockedSelected: [],
    manuallySelected: [],
    urgentSelected: [],
    showSelected: null,
    sortSelected: SORT.new,
    dateStart: null,
    dateStop: null,
  };
  @Input() options?: any;


  @Input() defaultFilter = {
    displayName: null,
    procName: null,
    tag: null,
    paramTypeSelected: [],
    valueTypeSelected: [],
    lockedSelected: [],
    manuallySelected: [],
    urgentSelected: [],
    showSelected: null,
    sortSelected: SORT.new,
    dateStart: new Date((new Date()).getTime() - 24 * 3600 * 1000),
    dateStop: null,
  };
  isMobile = this.deviceService.isMobile();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() clear: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  isChangedFilter = false;
  displayName = '';
  value_types;
  sorts = [
    {label: 'Newest first', value: SORT.new},
    {label: 'By error severity', value: SORT.critical},
  ];

  param_types = [
    {label: 'ContrDevice', value: 'DEVICE', title: 'CDP'},
    {label: 'Calc', value: 'CALC', title: 'CCP'},
  ];

  boolean_types = [
    {label: 'BOOLEAN.YES', value: 'true', title: 'BOOLEAN.YES'},
    {label: 'BOOLEAN.NO', value: 'false', title: 'BOOLEAN.NO'},
  ];

  calendarLocale = null;

  public init = false;

  public value_keep = {
    displayName: null,
    procName: null,
    tag: null,
    paramTypeSelected: [],
    valueTypeSelected: [],
    lockedSelected: [],
    manuallySelected: [],
    urgentSelected: [],
    showSelected: null,
    sortSelected: SORT.new,
    dateStart: null,
    dateStop: null,
  };

  enterPress = false;
  search: any = '';

  textInput = _.debounce(() => {
    if (this.enterPress) {
      this.enterPress = false;
      return false;
    }
    this.changeFilter();
  }, 1000);

  keyPress(filter, e) {
    try {
      if (filter === 'displayName' && ((this.value.displayName || '').length >= 3 || this.value.displayName.length === 0)) {
        this.textInput();
      } else if (filter === 'procName' && (this.value.procName.length >= 3 || this.value.procName.length === 0)) {
        this.textInput();
      } else if (filter === 'tag' && (this.value.tag.length >= 3 || this.value.tag.length === 0)) {
        this.textInput();
      }
    } catch (err) {}
  }


  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.init) {
       this.onClose();
      }
    }
    this.init = true;
  }



  constructor(private ngxTranslateService: TranslateService,
              private deviceService: DeviceDetectorService,
              private localeService: LocaleService,
              private cdRef: ChangeDetectorRef,
              private eRef: ElementRef) {
    this.value = {...this.defaultFilter};
    this.onChange();
    this.calendarLocale = this.localeService.getCalendarLocale();
  }

  ngOnInit(): void {
    forkJoin(
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.SIGNAL'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.SIGNAL'),
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.INSTANT'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.INSTANT'),
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.INCREMENTAL SUMMATION'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.INCREMENTAL SUMMATION'),
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.PULSE COUNTER'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.PULSE COUNTER'),
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.STRING'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.STRING'),
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.IMAGE'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.IMAGE'),
      this.ngxTranslateService.get('VALUE_TYPES.SHORT.TEXT'),
      this.ngxTranslateService.get('VALUE_TYPES.FULL.TEXT'),
    )
      .subscribe(response => {
        this.value_types = [
          {label: response[0], title: response[1], value: 'SIGNAL_1'},
          {label: response[2], title: response[3], value: 'SNAPSHOT_2'},
          {label: response[4], title: response[5], value: 'INCREASING_3'},
          {label: response[6], title: response[7], value: 'PULSE_COUNTER_4'},
          {label: response[8], title: response[9], value: 'STRING_5'},
          {label: response[10], title: response[11], value: 'IMAGE'},
          {label: response[12], title: response[13], value: 'TEXT'},
        ];
      });
  }

  compareFilter() {
    // if (this.value.paramTypeSelected === this.value_keep.param)
    this.isChangedFilter =
      this.value.paramTypeSelected.length !== 0 ||
      this.value.valueTypeSelected.length !== 0 ||
      this.value.lockedSelected !== null ||
      this.value.manuallySelected !== null ||
      this.value.urgentSelected !== null;
  }

  changeFilter(filter?, event?) {
    if (filter && event !== undefined)  {
      if (this.value[`${filter}`] === event ) {
        if (this.value[`${filter}`] === this.value_keep[`${filter}`]) {
          this.value[`${filter}`] = this.defaultFilter[`${filter}`];
        }
      }
    }
    this.value_keep = _.cloneDeep(this.value);
    this.dateChange(event);
  }

  clearFilterPeriod() {
    this.value.dateStart = this.defaultFilter.dateStart;
    this.value.dateStop = this.defaultFilter.dateStop;
    this.compareFilter();
    this.dateChange();
  }

  dateChange(event?) {
    this.init = false;
    this.onChange(event);
  }

  private propagateChange = (_: any) => {
  };

  /**
   * Write form value to the DOM element (model => view)
   */
  writeValue(value: any): void {
    this.value = value;
    this.cdRef.detectChanges();
  }

  /**
   * Update form when DOM element value changes (view => model)
   */
  registerOnChange(fn: any): void {
    // Store the provided function as an internal method.
    this.propagateChange = fn;
  }

  /**
   * Update form when DOM element is blurred (view => model)
   */
  registerOnTouched(fn: any): void {
    // Store the provided function as an internal method.
    this.onTouched = fn;
  }

  private onChange2(filter, event?) {
    if (event.data) {
      if (this.value[`${filter}`]) {
        this.value[`${filter}`] += event.data;
      }
    } else if (event.inputType === 'deleteConentForward') {

    }

  }

  private onChange(event?) {
    this.compareFilter();
    this.propagateChange(this.value);
    this.change.emit({value: this.value, changed: this.isChangedFilter});
  }

  private onTouched() {
  }

  private onClose() {
    this.close.emit();
  }

}





